var React = require('react');

function UiArrowThinRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ui-arrow-thin-right"),React.createElement("path",{"d":"M23.62,7a.78.78,0,0,0,0-.21.91.91,0,0,0-.11-.16s0,0,0,0l-6-6a.61.61,0,0,0-.88,0,.61.61,0,0,0,0,.88l4.93,4.94H1A.61.61,0,0,0,.38,7,.62.62,0,0,0,1,7.63H21.49l-4.93,4.93a.61.61,0,0,0,0,.88.6.6,0,0,0,.88,0l6-6s0,0,0,0a.91.91,0,0,0,.11-.16.78.78,0,0,0,0-.21s0,0,0,0S23.62,7,23.62,7Z","transform":"translate(-0.38 -0.38)","key":1})]);
}

UiArrowThinRight.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 23.25 13.25"};

module.exports = UiArrowThinRight;

UiArrowThinRight.default = UiArrowThinRight;
